import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import CyberSecurity from "../Utiilities/CyberSecurity";
import DemoButtons from "../Utiilities/DemoButtons";
import LMS_Slider from "../Utiilities/LMS_Slider";
function OverviewCommonLMS365(props) {
  const videoUrl = "https://youtu.be/AcJ9d1S6Ong";
  const [isLightboxOpen, setLightboxOpen] = React.useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = React.useState('');
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
  const closeLightbox = () => {
    setLightboxOpen(false);
  };
  const getEmbedUrl = (url) => {
    if (url.includes('youtube.com/watch?v=')) {
      return url.replace('watch?v=', 'embed/');
    } else if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1];
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes('vimeo.com/')) {
      const videoId = url.split('vimeo.com/')[1];
      return `https://player.vimeo.com/video/${videoId}`;
    } else {
      return url; // fallback for direct video links
    }
  };
  const handlePlayClick = () => {
    setIsVideoPlaying(true); // When play icon is clicked, play the video
  };
  const handleCloseVideo = () => {
    setIsVideoPlaying(false); // Close the video
  };
  return (
    <>
      <div style={{ background: "none" }} className="overviewsection ETOverViewSection" >
        <h2 className="HR_heading" style={{ marginBottom: "0vw", color: "#333" }}>Do you want to know the fastest way to close skill gaps?</h2>
        <p style={{ margin: "0" }}>Remove the learning friction first - Every separate platform, every extra login, every moment of friction turns 'I'll do it later' into never. LMS 365 embeds training directly into Microsoft Teams, SharePoint and Outlook, so there's nothing standing between intention and action. This eliminates the platform-hopping that stalls training completion & your teams finish what they start. LMS 365 ensures your business moves at the speed of their growth.
        </p>

<div style={{ margin: "1vw 0vw",display:"flex",justifyContent:"center",marginBottom:"1vw"}}>
<DemoButtons LMS365="LMS365" demobtnText="Remove the Completion Barrier Now"/>
</div>
<div>
  <LMS_Slider/>
</div>
        {/* <div style={{ position: "relative" }} >
          <img
            alt={props.MainImageAlt || "ET365"}
            src={props.MainImageSrc || "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/LMS-365_xHduHznyN.png"}

          />
          <div id="Features"></div>
          <div className='videoplysectio ET365-videoplysectio'>
            {videoUrl && !isVideoPlaying && (
              <div
                className='videoplayicon'
                onClick={handlePlayClick} // Only trigger video play when clicked
              >
                <FontAwesomeIcon icon={faPlayCircle} className='videoicon' />
                <button class="play-button">
                  <div class="play-icon"></div>
                </button>
              </div>
            )}
            {isVideoPlaying && videoUrl && (
              <div className="video-overlay" onClick={handleCloseVideo}>
                <div className="video-overlay-container" onClick={(e) => e.stopPropagation()}>
                  <div className="video-close-btn" onClick={handleCloseVideo}>
                    <FontAwesomeIcon icon={faClose} className="close-icon" />
                  </div>
                  <iframe
                    className="videoiframe"
                    src={getEmbedUrl(videoUrl)}
                    title="Embedded Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}

          </div>



        </div> */}

      </div>

    </>
  );
}

export default OverviewCommonLMS365;
